import { WSPage } from "@wingspanhq/fe-component-library";
import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { MyResourcesTab } from "../types";
import { PARAMETER_MY_RESOURCE_ID, PARAMETER_TAB } from "../paths";
import { InsuranceCoverageSource } from "@wingspanhq/wingspan-api-sdk";
import { queriesInsuranceCoverages } from "../../../v3/query/queriesInsuranceCoverages";
import { WSQueries } from "../../../query/WSQuery";
import { PlanEnrollmentDetails } from "./PlanEnrollmentDetails";
import { InsuranceImportDetails } from "./InsuranceImportDetails";

type Props = RouteComponentProps<{
  [PARAMETER_TAB]?: MyResourcesTab;
  [PARAMETER_MY_RESOURCE_ID]: string;
}>;

export const RouteMyResourceDetails: React.FC<Props> = ({ match, history }) => {
  const qInsuranceCoverage =
    queriesInsuranceCoverages.getInsuranceCoverage.useQuery({
      coverageId: match.params.myResourceId
    });

  return (
    <WSPage colorBackground="gray50">
      <WSQueries queries={{ qInsuranceCoverage }}>
        {({ qInsuranceCoverageData }) => {
          if (
            qInsuranceCoverageData.sourceType ===
            InsuranceCoverageSource.PLAN_ENROLLMENT
          ) {
            return (
              <PlanEnrollmentDetails
                tab={match.params.tab}
                insuranceCoverage={qInsuranceCoverageData}
              />
            );
          } else if (
            qInsuranceCoverageData.sourceType ===
            InsuranceCoverageSource.INSURANCE_IMPORT
          ) {
            return (
              <InsuranceImportDetails
                insuranceCoverage={qInsuranceCoverageData}
                tab={match.params.tab}
              />
            );
          }
        }}
      </WSQueries>
    </WSPage>
  );
};
